import { useParams, Link } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { useSubmission } from '@/hooks/useSubmissions'
import { WorkspaceLayout } from '@/components/workspace'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { ArrowLeft } from 'lucide-react'

export default function Workspace() {
  const { submissionId } = useParams<{ submissionId: string }>()
  const queryClient = useQueryClient()
  const { data: submission, isLoading, error } = useSubmission(submissionId)

  const handleStatusChange = () => {
    queryClient.invalidateQueries({ queryKey: ['submissions', 'detail', submissionId] })
  }

  if (isLoading) {
    return (
      <div className="flex h-screen flex-col">
        <div className="flex items-center gap-4 border-b p-4">
          <Skeleton className="h-10 w-10" />
          <Skeleton className="h-8 w-48" />
        </div>
        <div className="flex flex-1">
          <Skeleton className="w-1/4" />
          <Skeleton className="flex-1" />
          <Skeleton className="w-1/4" />
        </div>
      </div>
    )
  }

  if (error || !submission) {
    return (
      <div className="flex h-screen flex-col items-center justify-center">
        <p className="text-muted-foreground">Submission not found</p>
        <Button asChild variant="outline" className="mt-4">
          <Link to="/dashboard">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Link>
        </Button>
      </div>
    )
  }

  return (
    <WorkspaceLayout
      submission={submission}
      onStatusChange={handleStatusChange}
    />
  )
}
